import { queries } from 'apollo';
import * as React from 'react';
import { Query, QueryResult } from 'react-apollo';
import { Subtract } from 'utility-types';

interface IAboutPageDataResult {
  fetch: {
    Common: {
      About: {
        Color: string;
        BackgroundColor: string;
        Images: Array<{ Image: { src: string } | null }> | null;
      } | null;
      FAQ: {
        BackgroundColor: string | null;
        Lists: {
          NumberBackground: string | null;
          NumberActiveBackground: string | null;
          QuestionsBackground: string | null;
        } | null;
      } | null;
    };
    Country: {
      AboutPage: {
        AboutSections: Array<{
          Title: string;
          Content: string;
        }>;
        Subtitle: string;
        Title: string;
        FAQs: Array<{
          Title: string;
          Content: string;
        }>;
      };
    };
  };
}

interface IVariables {
  filters: {
    UrlKey: string;
  };
}

interface IRequiredProps {
  country: string;
}

export type WithAboutPageQueryProps = QueryResult<IAboutPageDataResult>;

class AboutPageQuery extends Query<IAboutPageDataResult, IVariables> {}

const withAboutPageQuery = <P extends WithAboutPageQueryProps>(
  Component: React.ComponentType<P>
): React.SFC<
  Subtract<P, WithAboutPageQueryProps> & IRequiredProps
> => props => {
  const { country } = props;
  return (
    <AboutPageQuery
      query={queries.GET_ABOUT_PAGE_DATA}
      variables={{
        filters: { UrlKey: country }
      }}
    >
      {providedProps => <Component {...providedProps} {...props as any} />}
    </AboutPageQuery>
  );
};

export default withAboutPageQuery;



// WEBPACK FOOTER //
// ./src/enhancers/withAboutPageQuery.tsx